import { h } from 'preact'
import Icon from '../assets'
import formatDateInLocalTimezone from '../utils/dateFormatting'
import DateFormatter from './DateFormatter'

interface Props {
  scheduledDate: number,
  scheduledBy: string,
  onShowCancelSchedule: () => void
}

const SchedulePublishConfirmation = ({ scheduledDate, scheduledBy, onShowCancelSchedule }: Props) => {
  const weekday = DateFormatter.weekdayLong(scheduledDate)
  const date = formatDateInLocalTimezone(scheduledDate)
  const timezone = DateFormatter.timezone('short')

  return (
    <div class='topic-creator__schedule-publish-confirmation'>
      <Icon icon='clock' width={16} height={16} />
      <div class='topic-creator__schedule-publish-confirmation-text'>Scheduled to be published for {weekday}, {date} ({timezone}) by {scheduledBy}</div>
      <div class='topic-creator__schedule-publish-confirmation-cancel'><a onClick={onShowCancelSchedule} class='qa-cancel-schedule'>Cancel schedule</a></div>
    </div>
  )
}

export default SchedulePublishConfirmation
